var login = function() {
    var logar = function (urlLogin) {
        var $botao = $("#btnLogin");
        if ($botao.hasClass("click-disabled"))
            return false;

        var resultado = violacoes.validarClient($("#formularioLogin"));

        if (resultado === false) {
            return false;
        } else {
            var btnLadda = $botao.ladda();
            btnLadda.ladda("start");
            $botao.addClass("click-disabled");
            $.post(urlLogin, $("#formularioLogin").serialize())
                .done(function(data) {
                    var json = JSON.parse(data);
                    if (json.Sucesso && json.UrlRetorno.trim() !== " ") {
                        window.location.href = json.UrlRetorno.replace("//","/");
                    } else {
                        btnLadda.ladda("stop");
                        $botao.removeClass("click-disabled");
                        violacoes.exibir($("#formularioLogin"), json.Violacoes, json.Mensagem);
                    }
                });
        }
    };

    return {
        logar: logar
    };
}();

$(document).ready(function () {
    $("body").keypress(function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode === 13) {
            $("#btnLogin").click();
        }
    });
});